// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { isShopThisStoreModeOn } from '../../../../reduxStore/selectors/session.selectors';

const getNavigationStylesForFilters = (props) => {
  const { isDidYouMeanEnabled } = props;
  const isShopThisStore = isShopThisStoreModeOn();
  const isNewNavEnabledDidMeanEnabled = `top: ${
    isShopThisStore ? '126px' : '88px'
  }; padding-top:10px;`;
  const isNewNavEnabledDidMeanNotEnabled = `top: ${
    isShopThisStore ? '148px' : '87px'
  };padding-top:10px;`;
  return `position: fixed;${
    isDidYouMeanEnabled ? isNewNavEnabledDidMeanEnabled : isNewNavEnabledDidMeanNotEnabled
  } `;
};

const getTopGap = (props) => {
  const { isHeaderStickyClassPresent, checkSTSCondensedHeaderHeight, stickyHeaderHeight } = props;
  if (isHeaderStickyClassPresent) {
    if (checkSTSCondensedHeaderHeight?.sTSCondensedHeaderPresent) {
      return stickyHeaderHeight + checkSTSCondensedHeaderHeight.sTSCondensedHeaderHeight;
    }
    return stickyHeaderHeight;
  }
  if (checkSTSCondensedHeaderHeight?.sTSCondensedHeaderPresent) {
    return checkSTSCondensedHeaderHeight.sTSCondensedHeaderHeight;
  }
  return 0;
};

const getTopGapwithGlobalHeader = (props) => {
  const { checkSTSCondensedHeaderHeight, headerMiddleNavHeight, isGlobalHeaderRedesignEnabled } =
    props;

  if (isGlobalHeaderRedesignEnabled) {
    if (checkSTSCondensedHeaderHeight?.sTSCondensedHeaderPresent) {
      return `
    top: ${
      parseInt(headerMiddleNavHeight, 10) -
      2 +
      checkSTSCondensedHeaderHeight.sTSCondensedHeaderHeight
    }px;
    position: sticky;
    `;
    }
    return `
    top: ${parseInt(headerMiddleNavHeight, 10) - 2}px;
    position: sticky;
    `;
  }
  if (checkSTSCondensedHeaderHeight?.sTSCondensedHeaderPresent) {
    return `
    top: ${checkSTSCondensedHeaderHeight.sTSCondensedHeaderHeight - 2}px;
    position: sticky;
    `;
  }
  return `top: 0;`;
};

const getNavigationStylesForFiltersTablet = (props) => {
  const { isDidYouMeanEnabled } = props;
  const isShopThisStore = isShopThisStoreModeOn();
  const isNewNavEnabledDidMeanEnabled = `top: ${isShopThisStore ? '126px' : '86px'};`;
  const isNewNavEnabledDidMeanNotEnabled = ` top: ${isShopThisStore ? '148px' : '86px'};`;
  return `${
    isDidYouMeanEnabled ? isNewNavEnabledDidMeanEnabled : isNewNavEnabledDidMeanNotEnabled
  } `;
};

export default css`
  .filter-redesign {
    .store-info {
      flex-direction: column;
    }
    .store-change-wrapper {
      margin: 0;
    }
    .bopis-filter-wrapper {
      height: fit-content;
      margin-bottom: 24px;
    }
    .count-section {
      ${(props) => (props.isPaginationViewEnabled ? ' font-weight: 600;' : '')}
      ${(props) => (props.isPaginationViewEnabled ? 'font-size: 16px;' : '')}
    }
  }
  .slp-grid-wrapper {
    margin-top: 20px;
  }
  .product-tile-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.SM}
      ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .filter-and-sort-form-container .desktop-dropdown {
    display: none;
  }
  .filter-and-sort-form-container .render-mobile-view {
    position: relative;
    width: auto;
    padding: 0;

    @media ${(props) => props.theme.mediaQuery.large} {
      display: none;
    }
  }
  .filter-and-sort-form-container .filter-row {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-left: 0;
    }
  }

  div.search-product-tile {
    margin-bottom: 20px;
    display: inline-block;
    text-align: center;
    width: calc(50% - 20px);
    isolation: isolate;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-bottom: 10px;
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 35px 0 0;
      width: calc(33.3% - 36px);
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 26px 0 0;
      margin-bottom: 0;
      width: calc(20% - 26px);
    }
  }
  .container-price {
    text-align: left;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .filter-row {
      margin-left: 0;
    }
    .mobile-sort-container .common-dropdown .item-common {
      padding-left: 8px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .render-mobile-view {
      display: none;
    }
    .filter-and-sort-form-container .desktop-dropdown {
      display: flex;
      position: relative;
      ${(props) =>
        props.isOneHrFilterEnabled ? `margin-top: ${props.theme.spacing.ELEM_SPACING.LRG_1}` : ``};
      &.shift-right {
        justify-content: flex-end;
      }
    }
  }

  .render-desktop-view {
    display: none;

    @media ${(props) => props.theme.mediaQuery.large} {
      display: block;
    }
  }
  .item-title {
    width: 100%;
  }

  .filtered-by-hide-utility {
    display: none;
  }

  .desktop-filter-sidebar {
    position: sticky;
    top: 47px;
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    .filtered-by-hide-utility {
      display: block;
    }
    .sticky-filter-clear-all-variant {
      text-transform: capitalize;
      text-decoration: underline;
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      color: ${(props) => props.theme.colorPalette.gray[900]};
      padding-left: 30px;
    }
    .sticky-filter-clear-all-variant:focus {
      background: none;
    }
    .open-filter-button.close-filter-button {
      width: 50%;
    }
    .render-mobile-view {
      display: block;
      .filter-row > div {
        width: 100%;
      }
      .open-filter-button {
        background: none;
        background-color: ${(props) => props.theme.colorPalette.white};
        border: none;
        text-align: left;
      }
    }
    .filter-and-sort-form-container {
      width: 100%;
    }
    .render-desktop-view {
      .desktop-dropdown,
      .filtered-by-section .filtering-title {
        display: none;
      }
    }
    .applied-filters-sorting-container .applied-filter-list {
      width: 100%;
    }
    .applied-filters-sorting-container {
      .applied-filter-item {
        margin-right: 0;
      }
    }
    .items-count-content {
      .show-label {
        display: none;
      }
    }
    .hide-sort-sidebar > .open-filter-button {
      display: none;
    }
  }
  @media ${(props) => props.theme.mediaQuery.desktop} {
    &.slp-extended-view {
      max-width: calc(100% - 26px);
      margin: 0 auto;
      div.search-product-tile {
        width: calc(17% - 33px);
      }

      .content-colors-button {
        margin-right: 8px;
      }

      .loyalty-text-container span {
        font-size: 12px;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .sticky-sort {
      z-index: 1;
      background-color: #fff;
      height: 54px;
      transition: all 0.3s ease-in-out;
      transform: translateY(0);
      ${(props) => (props.isHeaderSticky ? getNavigationStylesForFilters(props) : '')}
      ${(props) => {
        return !props.isHeaderScrollViewDisabled &&
          !props.isGlobalHeaderRedesignEnabled &&
          props.isHeaderSticky
          ? `
          position: sticky;
          top: ${getTopGap(props)}px;
      `
          : ``;
      }}
      ${(props) => {
        return props.isGlobalHeaderRedesignEnabled && getTopGapwithGlobalHeader(props);
      }}
    }

    .mb-24 {
      margin-bottom: 24px;
      justify-content: flex-end;
    }

    .half-width {
      max-width: 50%;
    }
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .sticky-sort {
      transition: all 0.3s ease-in-out;
      transform: translateY(0);
      ${(props) => (props.isHeaderSticky ? getNavigationStylesForFiltersTablet(props) : '')}
      ${(props) => {
        return props.isHeaderSticky &&
          !props.isHeaderScrollViewDisabled &&
          !props.isGlobalHeaderRedesignEnabled
          ? `
          position: sticky;
          top: ${getTopGap(props)}px;
      `
          : ``;
      }}
      ${(props) => {
        return props.isGlobalHeaderRedesignEnabled && getTopGapwithGlobalHeader(props);
      }}
    }
  }
`;
